import { cn } from '@wellesley/ui'
import { FC } from 'react'

type ForgotPasswordContainerProps = {
  title?: string
  description?: string
  children: React.ReactNode
  className?: string
}

export const ForgotPasswordContainer: FC<ForgotPasswordContainerProps> = ({
  title = 'Forgot Password',
  description,
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        'mx-auto flex w-[450px] flex-col items-center gap-m rounded-lg bg-white pb-m',
        className,
      )}
    >
      <h1 className="w-full border-b border-gray-200 py-m text-center text-lg font-semibold text-gray-700">
        {title}
      </h1>
      <div className="flex w-full flex-col gap-s px-m">
        {description && (
          <p
            className="text-center text-base font-medium text-gray-500"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}

        {children}
      </div>
    </div>
  )
}
